import { ThumbCheck } from '@/assets/icons/ThumbCheck';
import AppointmentCard from '@/components/appointment/AppointmentCard';
import ClinicianInfoCard from '@/components/appointment/ClinicianInfoCard';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import type { Appointment } from '@/types/order.type';

export const RescheduleAppointmentConfirmation = ({
  appointment,
  isPhoneCall,
}: {
  appointment: Appointment;
  isPhoneCall: boolean;
}) => {
  return (
    <Card className="gap-6">
      <CardHeader>
        <CardTitle className="flex flex-col items-center gap-4">
          <ThumbCheck className={cn('size-15')} />
          <h1>You're all set!</h1>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <p>Your appointment has been rescheduled.</p>

        <AppointmentCard appointment={appointment} isPhoneCall={isPhoneCall} />
        <ClinicianInfoCard clinician={appointment.provider} />
      </CardContent>
    </Card>
  );
};
